@if (isPageLoading) {
<div class="page-loader">
    <div class="loader-card">
        <span class="loader-brand">E.A.S.Y.&nbsp;<span class="brand-accent">Liens</span></span>
        <div class="loader-divider"></div>
        <div class="spinner"></div>
        <span class="loader-message">Loading…</span>
    </div>
</div>
}

@if (caseData) {
<div class="page-container">
    <div #stickySentinel class="page-header">
        <div class="header-main">
            <div class="header-title">{{ caseData.caseType }}</div>
            <span class="case-id">{{ caseData.id }}</span>
        </div>
        <div class="header-actions">

            @if (!isAttorney && !offerStatus) {
            <button class="btn btn-md btn-primary" (click)="openOfferModal()">
                <hugeicons-icon [icon]="editIcon" [size]="20" color="currentColor"></hugeicons-icon>
                Generate Offer
            </button>
            }
            @if (offerStatus && offerStatus !== 'PENDING') {
            <button class="btn btn-md btn-default" (click)="openViewOfferModal()">
                <hugeicons-icon [icon]="viewIcon" [size]="20" color="currentColor"></hugeicons-icon>
                View Offer
            </button>
            }
            @if (!isAttorney && (caseData.hospitalPayment === 0 || caseData.hospitalPayment === 1)) {
            <button class="btn btn-md btn-default" (click)="openViewHospitalPaymentModal()">
                <hugeicons-icon [icon]="viewIcon" [size]="20" color="currentColor"></hugeicons-icon>
                Hospital Payment Details
            </button>
            }

        </div>
    </div>
    <!-- Action Reminders (sticky) -->
    @if (offerDataLoaded && hasVisibleReminders) {
    <div #stickyWrapper class="sticky-reminders-wrapper">
        <app-case-reminders [reminders]="reminders" [caseProgress]="caseData.caseProgress"
            [moneyReceived]="caseData.moneyReceived || false" [offerStatus]="offerStatus">
        </app-case-reminders>
    </div>
    }
    <!-- Case Body -->
    <div class="case-body">
    <!-- Key Metrics Bar -->
    <div class="metrics-bar">
        <div class="metric-pill">
            <span class="metric-label">Lien Balance</span>
            <span class="metric-value primary">{{ caseData.lienBalance | currency }}</span>
        </div>
        @if (caseData.reductionAmount !== null) {
            <div class="metric-pill">
                <span class="metric-label">Reduction</span>
                <span class="metric-value">{{ caseData.reductionAmount | currency }}</span>
            </div>
        }
        @if (caseData.financials) {
            <div class="metric-pill">
                <span class="metric-label">Settlement</span>
                <span class="metric-value">{{ caseData.financials.settlementAmount | currency }}</span>
            </div>
            <div class="metric-pill">
                <span class="metric-label">Total Medicals</span>
                <span class="metric-value">{{ caseData.financials.totalMedicals | currency }}</span>
            </div>
        }
    </div>

    <div class="details-grid">
        <!-- Main Content -->
        <div class="main-content">
            <!-- Case Summary + Client + Lien — merged into one compact card -->
            <!-- Attorney -->
            <div class="content-card compact-card">
                    <div class="compact-section">
                        <div class="compact-section-title">Attorney Details</div>
                        <div class="compact-grid cols-2">
                            <div class="compact-item">
                                <label>Name</label>
                                <div class="value">{{ caseData.attorneyName }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Firm</label>
                                <div class="value">{{ caseData.attorneyFirm }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Email</label>
                                <div class="value">{{ caseData.attorneyEmail }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Phone</label>
                                <div class="value">{{ caseData.attorneyPhone }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            <!-- Patient Details -->
            <div class="content-card compact-card">
                <div class="compact-section">
                    <div class="compact-section-title">Patient Details</div>
                        <div class="compact-grid cols-2">
                            <div class="compact-item">
                                <label>Full Name</label>
                                <div class="value">{{ caseData.clientName }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Date of Birth</label>
                                <div class="value">{{ caseData.clientDob | date:'mediumDate' }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Email</label>
                                <div class="value">{{ caseData.clientEmail }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Phone</label>
                                <div class="value">{{ caseData.clientPhone }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Home Address</label>
                                <div class="value">{{ caseData.clientAddress }}</div>
                            </div>
                            <div class="compact-item">
                                <label>Patient Payment Posting Address</label>
                                <div class="value">{{ caseData.postingAddress }}</div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="content-card compact-card">
                <div class="compact-section">
                    <div class="compact-section-header">
                        <div class="compact-section-title">
                            Lien Details
                            <div class="compact-section-desc">Hospital lien and balance information</div>
                        </div>
                    </div>
                    <div class="compact-grid cols-4">
                        <div class="compact-item">
                            <label>Hospital Provider</label>
                            <div class="value">{{ caseData.hospitalName }}</div>
                        </div>
                        <div class="compact-item">
                            <label>Account Number</label>
                            <div class="value">{{ caseData.hospitalAccountNumber }}</div>
                        </div>
                        <div class="compact-item">
                            <label>Lien Balance</label>
                            <div class="value primary-value">{{ caseData.lienBalance | currency }}</div>
                        </div>
                        <div class="compact-item">
                            <label>Reductions</label>
                            <div class="value">{{ caseData.reductionsRequested ? 'Yes' : 'No' }}@if
                                (caseData.reductionAmount !== null) { — {{ caseData.reductionAmount | currency }}}</div>
                        </div>
                    </div>
                </div>
                <div class="compact-divider"></div>
                <div class="compact-section">
                    @if (caseData.prelimLienSummary && caseData.prelimLienSummary !== 'No summary provided') {
                        <div class="compact-grid cols-1">
                            <div class="compact-item">
                                <label>Preliminary Lien Summary</label>
                                <div class="value primary-value">{{ caseData.prelimLienSummary }}</div>
                            </div>
                        </div>
                    }
                </div>
                <div class="compact-divider"></div>
                <div class="compact-section">
                    @if (caseData.supportingDetails && caseData.supportingDetails !== 'No details provided') {
                        <div class="compact-grid cols-1">
                            <div class="compact-item">
                                <label>Supporting Details</label>
                                <div class="value primary-value">{{ caseData.supportingDetails }}</div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <!-- Submission Documents -->
            <div class="content-card compact-card">
                <div class="compact-section">
                    <div class="compact-section-title">Submission Documents</div>
                    <div class="compact-grid cols-2">
                        <div class="compact-item">
                            <label>Partial Closing Statement</label>
                            <div class="value">
                                @if (caseData.submissionDocs.partialClosingStatement.reason) {
                                    {{ caseData.submissionDocs.partialClosingStatement.reason }}
                                } @else if (caseData.submissionDocs.partialClosingStatement.status === 1) {
                                    @if (getSubmissionDocUrl(caseData.submissionDocs.partialClosingStatement)) {
                                        <a [href]="getSubmissionDocUrl(caseData.submissionDocs.partialClosingStatement)" target="_blank" class="file-link">View Attachment</a>
                                    } @else {
                                        Uploaded
                                    }
                                } @else {
                                    Not provided
                                }
                            </div>
                        </div>
                        <div class="compact-item">
                            <label>Itemized Bill / Invoice</label>
                            <div class="value">
                                @if (caseData.submissionDocs.billOrInvoice.reason) {
                                    {{ caseData.submissionDocs.billOrInvoice.reason }}
                                } @else if (caseData.submissionDocs.billOrInvoice.status === 1) {
                                    @if (getSubmissionDocUrl(caseData.submissionDocs.billOrInvoice)) {
                                        <a [href]="getSubmissionDocUrl(caseData.submissionDocs.billOrInvoice)" target="_blank" class="file-link">View Attachment</a>
                                    } @else {
                                        Uploaded
                                    }
                                } @else {
                                    Not provided
                                }
                            </div>
                        </div>
                        <div class="compact-item">
                            <label>Hospital Claim of Lien</label>
                            <div class="value">
                                @if (caseData.submissionDocs.hospitalClaimLien.reason) {
                                    {{ caseData.submissionDocs.hospitalClaimLien.reason }}
                                } @else if (caseData.submissionDocs.hospitalClaimLien.status === 1) {
                                    @if (getSubmissionDocUrl(caseData.submissionDocs.hospitalClaimLien)) {
                                        <a [href]="getSubmissionDocUrl(caseData.submissionDocs.hospitalClaimLien)" target="_blank" class="file-link">View Attachment</a>
                                    } @else {
                                        Uploaded
                                    }
                                } @else {
                                    Not provided
                                }
                            </div>
                        </div>
                        <div class="compact-item">
                            <label>Correspondence with Hospital</label>
                            <div class="value">
                                @if (caseData.submissionDocs.correspondenceLienholder.reason) {
                                    {{ caseData.submissionDocs.correspondenceLienholder.reason }}
                                } @else if (caseData.submissionDocs.correspondenceLienholder.status === 1) {
                                    @if (getSubmissionDocUrl(caseData.submissionDocs.correspondenceLienholder)) {
                                        <a [href]="getSubmissionDocUrl(caseData.submissionDocs.correspondenceLienholder)" target="_blank" class="file-link">View Attachment</a>
                                    } @else {
                                        Uploaded
                                    }
                                } @else {
                                    Not provided
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Document Center -->
            <app-case-document-center [inquiryId]="inquiryId" [caseCompleted]="caseData.caseProgress === 7"></app-case-document-center>
        </div>
        <!-- Sidebar -->
        <div class="side-content">
            <!-- Progress Stepper -->
            <div class="content-card sidebar-card stepper-card">
                <div class="sidebar-heading">
                    <div class="header-title">Case Progress</div>
                </div>
                <div class="stepper">
                    @for (step of progressSteps; track i; let i = $index; let last = $last) {
                    <div class="stepper-step" [ngClass]="step.status">
                        <div class="step-indicator">
                            <div class="step-circle">
                                @if (step.status === 'completed') {
                                <span class="step-check">&#10003;</span>
                                }
                                @if (step.status === 'rejected') {
                                <span class="step-cross">&#10005;</span>
                                }
                                @if (step.status === 'active' || step.status === 'pending') {
                                <span class="step-number">{{ i + 1 }}</span>
                                }
                            </div>
                            @if (!last) {
                            <div class="step-line"></div>
                            }
                        </div>
                        <div class="step-content">
                            <div class="step-label">{{ step.label }}</div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <!-- Financials Info -->
            @if (caseData.financials) {
            <div class="content-card sidebar-card">
                <div class="sidebar-heading">
                    <div class="header-title">Financials</div>
                </div>
                <div class="sidebar-list">
                    <div class="sidebar-list-row">
                        <span class="sidebar-list-label">Lien Amount</span>
                        <span class="sidebar-list-value">{{ caseData.financials.lienAmount | currency }}</span>
                    </div>
                    <div class="sidebar-list-row">
                        <span class="sidebar-list-label">Settlement</span>
                        <span class="sidebar-list-value">{{ getSettlementStatusLabel(caseData.financials.settlementStatus) }}</span>
                    </div>
                    @if (caseData.financials.settlementAmount) {
                    <div class="sidebar-list-row">
                        <span class="sidebar-list-label">Settlement Amt</span>
                        <span class="sidebar-list-value">{{ caseData.financials.settlementAmount | currency }}</span>
                    </div>
                    }
                    <div class="sidebar-list-row">
                        <span class="sidebar-list-label">Loans</span>
                        <span class="sidebar-list-value">{{ caseData.financials.settlementLoans ? 'Yes' : 'No' }}@if (caseData.financials.loanAmount) { — {{ caseData.financials.loanAmount | currency }}}</span>
                    </div>
                    <div class="sidebar-list-row">
                        <span class="sidebar-list-label">Total Medicals</span>
                        <span class="sidebar-list-value">{{ caseData.financials.totalMedicals | currency }}</span>
                    </div>
                    <div class="sidebar-list-row">
                        <span class="sidebar-list-label">Legal Fees</span>
                        <span class="sidebar-list-value">{{ caseData.financials.legalFees | currency }}</span>
                    </div>
                    <div class="sidebar-list-row">
                        <span class="sidebar-list-label">Costs</span>
                        <span class="sidebar-list-value">{{ caseData.financials.costs | currency }}</span>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    </div>
</div>
}

<!-- Payment Details Modal -->
<app-modal [isOpen]="showPaymentDetailsModal" [title]="'Payment Details'" [size]="'sm'" [showCloseButton]="true"
    [showFooter]="false" (close)="closePaymentDetailsModal()">
    @if (paymentDetails) {
    <div class="payment-detail-section">
        <div class="payment-item">
            <label>Full Name</label>
            <div class="value">{{ paymentDetails.full_name }}</div>
        </div>
        <div class="payment-item">
            <label>Phone Number</label>
            <div class="value">{{ formatPhone(paymentDetails.phone_number) }}</div>
        </div>
        @if (paymentDetails.email_address) {
        <div class="payment-item">
            <label>Email Address</label>
            <div class="value">{{ paymentDetails.email_address }}</div>
        </div>
        }
        <div class="payment-item">
            <label>Address Type</label>
            <div class="value">
                <span class="address-type-badge" [class.business]="paymentDetails.address_type === 'BUSINESS'"
                    [class.residence]="paymentDetails.address_type === 'RESIDENCE'">
                    {{ paymentDetails.address_type }}
                </span>
            </div>
        </div>
        <div class="payment-item">
            <label>Mailing Address</label>
            <div class="value">
                {{ paymentDetails.mailing_street }}, {{ paymentDetails.mailing_city }}, {{ paymentDetails.mailing_state
                }} {{ paymentDetails.mailing_zip }}
            </div>
        </div>
    </div>
    }
</app-modal>

<!-- Receipt Details Modal -->
<app-modal [isOpen]="showReceiptModal" [title]="'Receipt Details'" [size]="'sm'" [showCloseButton]="true"
    [showFooter]="false" (close)="showReceiptModal = false">
    @if (paymentDetails) {
    <div class="payment-detail-section">
        @if (paymentDetails.amount) {
        <div class="payment-item">
            <label>Amount</label>
            <div class="value">{{ paymentDetails.amount | currency }}</div>
        </div>
        }
        @if (paymentDetails.transaction_id) {
        <div class="payment-item">
            <label>Transaction ID</label>
            <div class="value">{{ paymentDetails.transaction_id }}</div>
        </div>
        }
        @if (paymentDetails.transaction_date) {
        <div class="payment-item">
            <label>Transaction Date</label>
            <div class="value">{{ paymentDetails.transaction_date | date: 'MMM d, yyyy' }}</div>
        </div>
        }
        @if (paymentDetails.status) {
        <div class="payment-item">
            <label>Status</label>
            <div class="value">
                <span class="payment-status-badge" [ngClass]="paymentDetails.status.toLowerCase()">
                    {{ paymentDetails.status }}
                </span>
            </div>
        </div>
        }
        @if (paymentDetails.receipt_path) {
        <div class="payment-item">
            <label>Receipt</label>
            <div class="value">
                <a [href]="paymentDetails.receipt_path" target="_blank" class="receipt-link">View Receipt File</a>
            </div>
        </div>
        }
    </div>
    }
</app-modal>

<!-- View Offer Modal -->
<app-modal [isOpen]="showViewOfferModal" [title]="'Offer Details'" [size]="'sm'"
    [showCloseButton]="true"
    [showCancelButton]="false" [showSubmitButton]="false" (close)="closeViewOfferModal()">
    <app-case-offer [offer]="offerData" [caseId]="caseId" [isAttorney]="isAttorney"
        [allDocumentsSigned]="allDocumentsSigned" [coverLetterDownloading]="coverLetterDownloading"
        [downloadingDocIndex]="downloadingDocIndex" [coverLetterViewing]="coverLetterViewing"
        [viewingDocIndex]="viewingDocIndex" (signDocument)="onSignDocument($event)"
        (downloadCoverLetter)="onDownloadCoverLetter()" (downloadDocPdf)="onDownloadDocPdf($any($event))"
        (viewCoverLetter)="onViewCoverLetter()" (viewDocPdf)="onViewDocPdf($any($event))">
    </app-case-offer>

    @if (isAttorney && offerData?.offer_status === 'PENDING') {
    <div footer class="offer-actions">
        <button type="button" class="btn-reject" (click)="rejectOffer()" [disabled]="offerActionLoading">
            Reject
        </button>
        <button type="button" class="btn-accept" (click)="acceptOffer()" [disabled]="offerActionLoading">
            Accept
        </button>
    </div>
    }
</app-modal>

<!-- Progress overlay — intentionally OUTSIDE app-modal so position:fixed works even when the modal is closed -->
@if (progressPercent !== null) {
<div class="progress-overlay">
    <div class="progress-card">
        <div class="progress-spinner-wrap">
            <svg class="progress-ring" viewBox="0 0 48 48">
                <circle class="progress-ring__bg" cx="24" cy="24" r="20" />
                <circle class="progress-ring__fill" cx="24" cy="24" r="20"
                    [style.strokeDashoffset]="125.6 - (125.6 * progressPercent / 100)" />
            </svg>
            <span class="progress-percent">{{ progressPercent }}%</span>
        </div>
        <div class="progress-label">{{ progressLabel }}</div>
    </div>
</div>
}

<!-- Document Preview & Sign Modal -->
<!-- Replaces the old Upload Document modal + E-Signature modal -->
<app-documents-preview-modal [isOpen]="showDocumentsModal" [caseId]="inquiryId" [startDocIndex]="docSignIndex"
    [startMode]="docStartMode" [rejectedDocIndices]="docRejectedIndices" [offerDocuments]="offerData?.documents || []"
    (close)="onDocumentsModalClose()">
</app-documents-preview-modal>

<!-- View Submitted Documents Modal (Attorney) -->
<app-modal [isOpen]="showSubmittedDocsModal" title="Submitted Documents" size="md" [showFooter]="false"
    [showCloseButton]="true" (close)="closeSubmittedDocsModal()">
    @if (submittedSignedDocuments.length === 0) {
    <div style="text-align: center; color: var(--text-tertiary); padding: 24px 0;">No submitted documents yet.</div>
    } @else {
    <div class="submitted-docs-list">
        @for (doc of submittedSignedDocuments; track doc.id) {
        <div class="submitted-doc-item">
            <span class="submitted-doc-name">{{ doc.document_type }}</span>
            <button class="btn btn-sm btn-default" (click)="viewSignedDocInNewTab(doc)">
                <hugeicons-icon [icon]="viewIcon" [size]="14"></hugeicons-icon>
                View
            </button>
        </div>
        }
    </div>
    }
</app-modal>

<!-- Review Signed Documents Modal (Admin) -->
<app-modal [isOpen]="showReviewDocsModal" title="Review Signed Documents" size="md" [showFooter]="false"
    [showCloseButton]="true" (close)="closeReviewDocsModal()">
    <div class="review-docs-list">
        @for (doc of signedDocumentsPendingReview; track doc.id) {
        <div class="review-doc-item">
            <div class="review-doc-info">
                <hugeicons-icon [icon]="fileIcon" [size]="20" color="currentColor"></hugeicons-icon>
                <div class="review-doc-meta">
                    @if (isDocActioned(doc)) {
                    <span class="review-doc-status-tag" [class.tag-accepted]="isDocAccepted(doc)"
                        [class.tag-rejected]="isDocRejected(doc)">
                        {{ isDocAccepted(doc) ? 'Accepted' : 'Rejected' }}
                    </span>
                    }
                    <span class="review-doc-name">{{ doc.document_type }}</span>
                    <div class="review-doc-actions">
                        <a [href]="getSignedDocUrl(doc)" target="_blank" class="btn btn-sm btn-default">
                            View
                        </a>
                        @if (!isDocActioned(doc)) {
                        <button class="btn btn-sm btn-primary" [disabled]="docActionSubmitting[doc.id]"
                            (click)="approveDocument(doc)">
                            @if (docActionSubmitting[doc.id]) { <span class="spinner"></span> }
                            Accept
                        </button>
                        <button class="btn btn-sm btn-danger" [disabled]="docActionSubmitting[doc.id]"
                            (click)="rejectDocument(doc)">
                            @if (docActionSubmitting[doc.id]) { <span class="spinner"></span> }
                            Reject
                        </button>
                        }
                    </div>
                </div>
            </div>
        </div>
        }
        @if (signedDocumentsPendingReview.length === 0) {
        <div class="review-docs-empty">No signed documents to review.</div>
        }
    </div>
</app-modal>

<!-- Offer Modal -->
<app-modal [isOpen]="showOfferModal" [title]="'Generate Offer'" [size]="'sm'" [showCloseButton]="false"
    [submitButtonText]="'Submit Offer'" [submitButtonDisabled]="offerForm.invalid" (close)="closeOfferModal()"
    (cancel)="closeOfferModal()" (submit)="submitOffer()">
    <form [formGroup]="offerForm">
        <div class="form-group mb-12">
            <label>Offer Amount</label>
            <input appAmountFormat formControlName="offer_amount" placeholder="Enter offer amount">
        </div>
        <div class="form-group mb-12">
            <label>Confirm Offer Amount</label>
            <input appAmountFormat formControlName="confirm_offer_amount" placeholder="Confirm offer amount">
            @if (offerForm.hasError('amountMismatch') && offerForm.get('confirm_offer_amount')?.touched) {
            <span class="error-msg">Offer amounts do not match</span>
            }
        </div>
        <div class="form-group mb-12">
            <label>Instructions</label>
            <textarea formControlName="instructions" placeholder="Enter instructions"></textarea>
        </div>
    </form>
</app-modal>

<!-- Send Payment Modal -->
<app-modal [isOpen]="showSendPaymentModal" [title]="'Send Payment'" [size]="'sm'" [showCloseButton]="false"
    [closeOnBackdropClick]="false" [submitButtonText]="sendPaymentSubmitting ? 'Sending...' : 'Send Payment'"
    [submitButtonDisabled]="sendPaymentForm.invalid || sendPaymentSubmitting" (close)="closeSendPaymentModal()"
    (cancel)="closeSendPaymentModal()" (submit)="submitSendPayment()">
    <form [formGroup]="sendPaymentForm">
        <div class="form-grid cols-1">
            <div class="form-group mb-6">
                <label>Transaction ID</label>
                <input type="text" formControlName="transaction_id" placeholder="Enter transaction ID">
                @if (sendPaymentForm.get('transaction_id')?.invalid && sendPaymentForm.get('transaction_id')?.touched) {
                <span class="error-msg">Transaction ID is required</span>
                }
            </div>
            <div class="form-group mb-6">
                <label>Transaction Date</label>
                <app-date-picker formControlName="transaction_date"
                    placeholder="Select transaction date"></app-date-picker>
                @if (sendPaymentForm.get('transaction_date')?.invalid &&
                sendPaymentForm.get('transaction_date')?.touched) {
                <span class="error-msg">Transaction date is required</span>
                }
            </div>
            <div class="form-group mb-6">
                <label>Amount</label>
                <input appAmountFormat formControlName="amount" placeholder="Enter amount">
                @if (sendPaymentForm.get('amount')?.invalid && sendPaymentForm.get('amount')?.touched) {
                <span class="error-msg">Amount is required</span>
                }
            </div>
            <div class="form-group">
                <app-file-upload formControlName="receipt" label="Receipt" [required]="false"
                    accept=".pdf,.jpg,.jpeg,.png" hint="PDF, JPG, PNG (up to 25MB)"
                    [hasError]="!!(sendPaymentForm.get('receipt')?.invalid && sendPaymentForm.get('receipt')?.touched)">
                </app-file-upload>
                @if (sendPaymentForm.get('receipt')?.invalid && sendPaymentForm.get('receipt')?.touched) {
                <span class="error-msg">Receipt is required</span>
                }
            </div>
        </div>
    </form>
</app-modal>

<!-- Payment Details Modal -->
<app-modal [isOpen]="showPaymentModal" [title]="'Payment Details'" [size]="'sm'" [showCloseButton]="false"
    [closeOnBackdropClick]="false" [submitButtonText]="paymentSubmitting ? 'Submitting...' : 'Submit Detail'"
    [submitButtonDisabled]="paymentForm.invalid || paymentSubmitting" (close)="closePaymentModal()"
    (cancel)="closePaymentModal()" (submit)="submitPayment()">
    <form [formGroup]="paymentForm" class="app-form">
        <div class="payment-modal-body">
            <!-- Personal Information Section -->
            <div class="form-section">
                <div class="form-grid cols-1">
                    <div class="form-group">
                        <label>Full Name</label>
                        <input type="text" formControlName="full_name" placeholder="Enter full name">
                    </div>
                    <div class="form-group">
                        <label>Business or Residence?</label>
                        <div class="radio-group">
                            <label class="radio-option">
                                <input type="radio" formControlName="address_type" value="BUSINESS">
                                <span class="radio-label">Business</span>
                            </label>
                            <label class="radio-option">
                                <input type="radio" formControlName="address_type" value="RESIDENCE">
                                <span class="radio-label">Residence</span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Mailing Address (Street)</label>
                        <input type="text" formControlName="mailing_street" placeholder="Enter street address">
                    </div>
                    <div class="form-group">
                        <label>State</label>
                        <input type="text" formControlName="mailing_state" placeholder="State">
                    </div>
                    <div class="form-grid cols-2">
                        <div class="form-group">
                            <label>City</label>
                            <input type="text" formControlName="mailing_city" placeholder="City">
                        </div>
                        <div class="form-group">
                            <label>Zip</label>
                            <input type="text" formControlName="mailing_zip" placeholder="Zip code" maxlength="10">
                            @if (paymentForm.get('mailing_zip')?.invalid && paymentForm.get('mailing_zip')?.touched) {
                            <span class="error-msg">
                                @if (paymentForm.get('mailing_zip')?.hasError('required')) {
                                Zip code is required
                                } @else if (paymentForm.get('mailing_zip')?.hasError('pattern')) {
                                Enter a valid zip code
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Phone Number</label>
                        <input type="tel" formControlName="phone_number" placeholder="Enter phone number"
                            maxlength="10">
                        @if (paymentForm.get('phone_number')?.invalid && paymentForm.get('phone_number')?.touched) {
                        <span class="error-msg">
                            @if (paymentForm.get('phone_number')?.hasError('required')) {
                            Phone number is required
                            } @else if (paymentForm.get('phone_number')?.hasError('pattern')) {
                            Phone number must be 10 digits
                            }
                        </span>
                        }
                    </div>
                    <div class="form-group">
                        <label>Email Address <span class="optional-label">(optional)</span></label>
                        <input type="email" formControlName="email_address" placeholder="Enter email address">
                    </div>
                </div>
            </div>
        </div>
    </form>
</app-modal>

<!-- Received Payment Modal -->
<app-modal [isOpen]="showReceivedPaymentModal" [title]="'Payment Receipt'" [size]="'sm'" [showCloseButton]="true"
    [showFooter]="false" (close)="closeReceivedPaymentModal()">
    @if (paymentDetails) {
    <div class="payment-detail-section">
        <div class="payment-item">
            <label>Transaction ID</label>
            <div class="value">{{ paymentDetails.transaction_id || '—' }}</div>
        </div>
        <div class="payment-item">
            <label>Transaction Date</label>
            <div class="value">{{ paymentDetails.transaction_date ? (paymentDetails.transaction_date |
                date:'mediumDate') : '—' }}</div>
        </div>
        <div class="payment-item">
            <label>Amount</label>
            <div class="value">{{ paymentDetails.amount ? (paymentDetails.amount | currency) : '—' }}</div>
        </div>
        @if (paymentDetails.receipt_path) {
        <div class="payment-item">
            <label>Attachments</label>
            <div class="value">
                <a [href]="(paymentDetails.receipt_path)" target="_blank" class="btn btn-sm btn-default">
                    <hugeicons-icon [icon]="viewIcon" [size]="16" color="currentColor"></hugeicons-icon>
                    View
                </a>
            </div>
        </div>
        }
    </div>
    }
</app-modal>

<!-- Release of Lien Modal -->
<app-modal [isOpen]="showReleaseOfLienModal" [title]="'Upload Release of Lien'" [size]="'sm'" [showCloseButton]="false"
    [closeOnBackdropClick]="false" [submitButtonText]="releaseOfLienSubmitting ? 'Uploading...' : 'Upload Document'"
    [submitButtonDisabled]="releaseOfLienForm.invalid || releaseOfLienSubmitting" (close)="closeReleaseOfLienModal()"
    (cancel)="closeReleaseOfLienModal()" (submit)="submitReleaseOfLien()">
    <form [formGroup]="releaseOfLienForm">
        <div class="release-lien-desc">Upload the signed Release of Lien document to complete the case settlement. This
            document confirms the lien has been formally released.</div>
        <div class="form-group">
            <app-file-upload formControlName="document" label="Release of Lien Document" [required]="true"
                accept=".pdf,.jpg,.jpeg,.png" hint="PDF, JPG, PNG (up to 25MB)">
            </app-file-upload>
        </div>
    </form>
</app-modal>

<!-- We Received Money Confirmation Modal -->
<app-modal [isOpen]="showReceivedMoneyConfirmModal" [title]="'Confirm Received Payment'" [size]="'sm'" [showCloseButton]="false"
    [closeOnBackdropClick]="false" [submitButtonText]="receivedMoneySubmitting ? 'Confirming...' : 'Yes, We Received It'"
    [submitButtonDisabled]="receivedMoneyForm.invalid || receivedMoneySubmitting" (close)="closeReceivedMoneyConfirmModal()"
    (cancel)="closeReceivedMoneyConfirmModal()" (submit)="confirmReceivedMoney()">
    <div class="crp-warning-banner">
        Once you confirm, this case will be <strong>officially closed</strong>. This action can't be reversed.
    </div>
    <form [formGroup]="receivedMoneyForm">
        <div class="form-group mb-6">
            <label>Amount</label>
            <input appAmountFormat formControlName="amount" placeholder="Enter amount">
            @if (receivedMoneyForm.get('amount')?.invalid && receivedMoneyForm.get('amount')?.touched) {
            <span class="error-msg">Amount is required</span>
            }
        </div>
        <div class="form-group mb-6">
            <label>Check ID</label>
            <input type="text" formControlName="cheque_id" placeholder="Enter check ID">
            @if (receivedMoneyForm.get('cheque_id')?.invalid && receivedMoneyForm.get('cheque_id')?.touched) {
            <span class="error-msg">Check ID is required</span>
            }
        </div>
        <div class="form-group mb-6">
            <label>Date Received</label>
            <app-date-picker formControlName="cheque_date" placeholder="Select date received"></app-date-picker>
            @if (receivedMoneyForm.get('cheque_date')?.invalid && receivedMoneyForm.get('cheque_date')?.touched) {
            <span class="error-msg">Date received is required</span>
            }
        </div>
        <div class="form-group">
            <app-file-upload formControlName="attachement" label="Attachment" [required]="true"
                accept=".pdf,.jpg,.jpeg,.png" hint="PDF, JPG, PNG (up to 25MB)"
                [hasError]="!!(receivedMoneyForm.get('attachement')?.invalid && receivedMoneyForm.get('attachement')?.touched)">
            </app-file-upload>
            @if (receivedMoneyForm.get('attachement')?.invalid && receivedMoneyForm.get('attachement')?.touched) {
            <span class="error-msg">Attachment is required</span>
            }
        </div>
    </form>
</app-modal>

<!-- Celebration Overlay -->
@if (showCelebration) {
<div class="celebration-overlay">
    <!-- Confetti -->
    <div class="confetti-container">
        @for (i of
        [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50];
        track i) {
        <div class="confetti-piece" [style.--delay]="(i * 0.08) + 's'" [style.--left]="(i * 2) + '%'"
            [style.--speed]="(2.5 + (i % 4) * 0.5) + 's'">
        </div>
        }
    </div>

    <!-- Center card -->
    <div class="celebration-content">
        <div class="celebration-title">Case Closed!</div>
        <div class="celebration-badge">
            <span class="badge-dot"></span>
            Successfully Completed
        </div>
        <div class="celebration-divider"></div>
        <div class="celebration-text">The payment has been received and<br>the case is now officially closed.</div>
        <div class="celebration-progress-bar">
            <div class="celebration-progress-fill"></div>
        </div>
        <div class="celebration-hint">↻ &nbsp;Refreshing in a moment...</div>
    </div>

</div>
}

<!-- Hidden render area for cover letter PDF generation -->
@if (showCoverLetterRender) {
<div style="position:absolute;top:-99999px;left:0;opacity:0;pointer-events:none;overflow:visible;">
    <app-doc-cover-letter #coverLetterDownloadComp [caseData]="coverLetterData"></app-doc-cover-letter>
</div>
}

<!-- Hidden render area for document PDF generation -->
@if (showDocPdfRender) {
<div style="position:absolute;top:-99999px;left:0;opacity:0;pointer-events:none;overflow:visible;">
    @if (docPdfIndex === 0) {
    <app-doc-acknowledgment #ackDownloadComp [caseData]="docPdfData" [state]="blankDocState">
    </app-doc-acknowledgment>
    } @else if (docPdfIndex === 1) {
    <app-doc-assignment-trust-funds #atfDownloadComp [caseData]="docPdfData" [state]="blankDocState">
    </app-doc-assignment-trust-funds>
    } @else {
    <app-doc-hipaa-authorization #hipaaDownloadComp [caseData]="docPdfData" [state]="blankDocState">
    </app-doc-hipaa-authorization>
    }
</div>
}

<!-- Hidden render area for Release of Lien PDF generation -->
@if (showRolPdfRender) {
<div style="position:absolute;top:-99999px;left:0;opacity:0;pointer-events:none;overflow:visible;">
    <app-doc-release-of-lien #rolDownloadComp [caseData]="rolPdfData" [state]="blankDocState">
    </app-doc-release-of-lien>
</div>
}

<!-- View Hospital Payment Details Modal -->
<app-modal
    [isOpen]="showViewHospitalPaymentModal"
    [title]="'Hospital Payment Details'"
    [size]="'sm'"
    [showCloseButton]="true"
    [showFooter]="false"
    (close)="showViewHospitalPaymentModal = false">
    @if (hospitalPaymentData) {
        <div class="hp-detail">
            <div class="hp-detail-card">
                <div class="hp-detail-row">
                    <div class="hp-detail-item">
                        <label>Hospital Name</label>
                        <div class="hp-detail-value">{{ hospitalPaymentData.hospital_name }}</div>
                    </div>
                    <div class="hp-detail-item">
                        <label>Phone Number</label>
                        <div class="hp-detail-value">{{ formatPhone(hospitalPaymentData.phone_number) }}</div>
                    </div>
                </div>
                <div class="hp-detail-row">
                    <div class="hp-detail-item full">
                        <label>Address</label>
                        <div class="hp-detail-value">{{ hospitalPaymentData.address }}</div>
                    </div>
                </div>
                <div class="hp-detail-row">
                    <div class="hp-detail-item">
                        <label>Street</label>
                        <div class="hp-detail-value">{{ hospitalPaymentData.street }}</div>
                    </div>
                    <div class="hp-detail-item">
                        <label>City</label>
                        <div class="hp-detail-value">{{ hospitalPaymentData.city }}</div>
                    </div>
                </div>
                <div class="hp-detail-row">
                    <div class="hp-detail-item">
                        <label>State</label>
                        <div class="hp-detail-value">{{ hospitalPaymentData.state }}</div>
                    </div>
                    <div class="hp-detail-item">
                        <label>Zip Code</label>
                        <div class="hp-detail-value">{{ hospitalPaymentData.zipcode }}</div>
                    </div>
                </div>
            </div>
            <div class="hp-detail-card">
                <div class="hp-detail-row">
                    <div class="hp-detail-item">
                        <label>Amount</label>
                        <div class="hp-detail-value hp-amount">{{ hospitalPaymentData.amount | currency }}</div>
                    </div>
                    @if (hospitalPaymentData.amount_paid) {
                    <div class="hp-detail-item">
                        <label>Amount Paid</label>
                        <div class="hp-detail-value hp-amount">{{ hospitalPaymentData.amount_paid | currency }}</div>
                    </div>
                    }
                    <div class="hp-detail-item">
                        <label>Status</label>
                        <div class="hp-detail-value">
                            <span class="payment-status-badge" [ngClass]="hospitalPaymentData.status?.toLowerCase()">
                                {{ hospitalPaymentData.status }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            @if (hospitalPaymentData.attachement_path) {
            <a [href]="offerData?.default_url + '/' + hospitalPaymentData.attachement_path" target="_blank" class="hp-attachment-btn">
                <hugeicons-icon [icon]="viewIcon" [size]="16" color="currentColor"></hugeicons-icon>
                View Attachment
            </a>
            }
            @if (hospitalPaymentData.admin_attachment_path) {
            <a [href]="offerData?.default_url + '/' + hospitalPaymentData.admin_attachment_path" target="_blank" class="hp-attachment-btn">
                <hugeicons-icon [icon]="viewIcon" [size]="16" color="currentColor"></hugeicons-icon>
                View Admin Attachment
            </a>
            }
        </div>
    } @else {
        <div style="text-align: center; padding: 24px; color: var(--text-tertiary);">No hospital payment details available.</div>
    }
</app-modal>

<!-- Update Hospital Payment Status Modal -->
<app-modal
    [isOpen]="showUpdateHospitalPaymentModal"
    [title]="'Update Hospital Payment'"
    [size]="'sm'"
    [contentClass]="'overflow-visible'"
    [showCloseButton]="true"
    [closeOnBackdropClick]="false"
    [submitButtonText]="updateHospitalPaymentSubmitting ? 'Submitting...' : 'Submit'"
    [submitButtonDisabled]="updateHospitalPaymentForm.invalid || updateHospitalPaymentSubmitting"
    (close)="closeUpdateHospitalPaymentModal()"
    (cancel)="closeUpdateHospitalPaymentModal()"
    (submit)="submitUpdateHospitalPayment()">
    <form [formGroup]="updateHospitalPaymentForm" class="app-form">
        <div class="form-group mb-6">
            <label>Transaction ID</label>
            <input type="text" formControlName="transaction_id" placeholder="Enter transaction ID">
        </div>
        <div class="form-group mb-6">
            <app-date-picker formControlName="transaction_date" label="Transaction Date" placeholder="Select transaction date"></app-date-picker>
        </div>
        <div class="form-group mb-6">
            <label>Amount</label>
            <input appAmountFormat formControlName="amount" placeholder="Enter amount">
        </div>
        <div class="form-group">
            <app-file-upload formControlName="receipt" label="Receipt" [required]="true"
                accept=".pdf,.jpg,.jpeg,.png" hint="PDF, JPG, PNG (up to 25MB)"
                [hasError]="!!(updateHospitalPaymentForm.get('receipt')?.invalid && updateHospitalPaymentForm.get('receipt')?.touched)">
            </app-file-upload>
        </div>
    </form>
</app-modal>

<!-- Hospital Payment Modal -->
<app-modal
    [isOpen]="showHospitalPaymentModal"
    [title]="'Provider Resolution Details'"
    [size]="'sm'"
    [showCloseButton]="true"
    [closeOnBackdropClick]="false"
    [submitButtonText]="hospitalPaymentSubmitting ? 'Submitting...' : 'Submit'"
    [submitButtonDisabled]="hospitalPaymentForm.invalid || hospitalPaymentSubmitting"
    (close)="closeHospitalPaymentModal()"
    (cancel)="closeHospitalPaymentModal()"
    (submit)="submitHospitalPayment()">
    <form [formGroup]="hospitalPaymentForm" class="app-form">
        <div class="form-group mb-6">
            <label>Hospital Name</label>
            <input type="text" formControlName="hospital_name" placeholder="Enter hospital name">
        </div>
        <div class="form-group mb-6">
            <label>Phone Number</label>
            <input appPhoneFormat formControlName="phone_number" placeholder="Enter phone number">
        </div>
        <div class="form-group mb-6">
            <label>Address 1</label>
            <input type="text" formControlName="address" placeholder="Enter address 1">
        </div>
        <div class="form-grid cols-2">
            <div class="form-group mb-6">
                <label>Address 2</label>
                <input type="text" formControlName="street" placeholder="Enter address 2">
            </div>
            <div class="form-group mb-6">
                <label>City</label>
                <input type="text" formControlName="city" placeholder="Enter city">
            </div>
            <div class="form-group mb-6">
                <label>State</label>
                <input type="text" formControlName="state" placeholder="Enter state">
            </div>
            <div class="form-group mb-6">
                <label>Zip Code</label>
                <input type="text" formControlName="zipcode" placeholder="Enter zip code">
            </div>
        </div>
        <div class="form-group mb-6">
            <label>Amount</label>
            <input appAmountFormat formControlName="amount" placeholder="Enter amount">
        </div>
        <div class="form-group">
            <app-file-upload formControlName="attachement" label="Easy Resolution Attachment" [required]="true"
                accept=".pdf,.jpg,.jpeg,.png" hint="PDF, JPG, PNG (up to 25MB)"
                [hasError]="!!(hospitalPaymentForm.get('attachement')?.invalid && hospitalPaymentForm.get('attachement')?.touched)">
            </app-file-upload>
        </div>
    </form>
</app-modal>

